<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>东莞首例!两家国企同时收购一家私企股权!</h2>
        <img width="100%" :src="img[0]" alt="" >
        <p>9月27日上午，广东东鸿物业发展有限公司(下称“东鸿公司”)、东莞港湾区快线集团有限公司(下称“湾区快线集团”) 与广东东尚环保科技 有限公司(下称“广东东尚公司”)三方签署广东东进有害生物防控技术有限公司(下称“东进公司”)股权转让协议，东进公司正式成为东鸿公司的控股子公司、湾区快线集团的参股子公司，这是东鸿公司、湾区快线集团在有害生物防控产业布局上迈出重要的一步，也开创了我市两家国企同时收购一家私企股权的先河，具有典型示范意义。
        </p>
        <p>
          东实集团董事会秘书夏林幽，湾区快线集团董事长练泽开、总经理林霓，东鸿公司总经理朱雷、副总经理朱金和，广东东尚公司总经理王伟，东莞市有害生物防制协会执行秘书长徐兵兵、党支部书记钟毓灵，以及城开公司总经理董华智、安居公司总经理季光正、南城商务区公司总经理莫海明、东实长华公司总经理刘坤、大创公司副总经理文龙、骏安公司副总经理王铁成等多家集团下属公司领导受邀出席了签约仪式。
        </p>
        <h3 style="border-bottom: 2px solid #f4c527; padding-bottom: 2px">广东东尚公司 <br> 总经理王伟致辞! </h3>
        <el-row :gutter="20">
          <el-col :span="12" :xs="24" :offset="0">
            <p><img width="100%" :src="img[1]" alt=""></p>
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <p>
              广东东尚公司总经理王伟在致辞中表示，此次股权转让协议签约仪式的顺利举行，标志着东进公司发展进程翻开了新篇章。签约后，东进公司有了国有资本的良好信用背书，公司上下会切实将思想和行动统一到东实集团的决策部署当中来，积极维护好国企形象，整合项目资源，完善管理机制，牢牢抓住机遇，以更高度的政治站位、更严格的工作标准、更优良的技术服务，研砺奋进，团结进取，实现东进公司的跨越式发展，以优异的业绩向各方股东交出一份满意的答卷。
            </p>
          </el-col>
        </el-row>
        <h3 style="border-bottom: 2px solid #f4c527; padding-bottom: 2px">湾区快线集团 <br> 董事长练泽开致辞 </h3>
        <el-row :gutter="20">
          <el-col :span="12" :xs="24" :offset="0">
            <p>
              湾区快线集团董事长练泽开致辞表示，经过三方的共同努力，三方合作在今天终于“开花结果”，此次签约是三方开展合作的新开端，必将打开有害生物防制行业发展的新局面，为三方实现共同发展奠定良好的基石，相信经过三方的精诚合作、互惠互利、共谋发展，一定能结出丰硕成果、实现共赢。下来，湾区快线集团将会以这次签约为契机，进一步深化各方合作，实现优势互补、资源共享，全力支持东进公司在港口拓展业务，助力东进公司高质量发展。
            </p>
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <p><img width="100%" :src="img[2]" alt=""></p>
          </el-col>
        </el-row>
        <h3 style="border-bottom: 2px solid #f4c527; padding-bottom: 2px">东鸿公司 <br> 总经理朱雷致辞 </h3>
        <el-row :gutter="20">
          <el-col :span="12" :xs="24" :offset="0">
            <p><img width="100%" :src="img[3]" alt=""></p>
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <p>
              东鸿公司总经理朱雷在致辞中表示，此次入股东进公司，是东鸿公司顺应物业管理行业发展趋势，深耕物管领域的又一重要产业布局，也是落实东实集团中长期发展战略和“深化改革三年行动”实施方案的重要举措。东鸿公司将紧紧抓住这一难得契机，充分发挥自身优势，本着“资源共享.优势互补、合作共赢”的原则，与广东东尚公司、湾区快线集团携手共进精诚合作，实现协同发展、互利共赢的共同目标，收获累累硕果!同时，他期望东进公司全体员工能够讯速转变思想观念，积极主动适应国企治理新环境、新方式，争创企业经营发展新业绩、新高度。
            </p>
          </el-col>
        </el-row>
        <h3 style="border-bottom: 2px solid #f4c527; padding-bottom: 2px">东实集团 <br> 董事会秘书夏林幽致辞 </h3>
        <el-row :gutter="20">
          <el-col :span="12" :xs="24" :offset="0">
            <p>
              东实集团董事会秘书夏林幽在致辞中指出，早在2014年，东实集团党委高瞻远瞩、把握时机，决定成立一家国有性质的物业管理公司，致力为东莞城市发展提供专业、优质的物业服务。历经八年多的发展，东鸿公司如今已发展成为一家在东莞物管行业具有较强实力、良好口碑、稳定盈利的物业公司，是东实集团城市综合运营板块的重要版图之一。夏总表示，此次东鸿公司控股东进公司，是东鸿公司布局有害生物防制新领域、拓展物业管理领域新业务的重要举措，希望东鸿公司充分抓住这一发展契机，加快业务布局，加强团队建设，指导和监督东进公司在企业的治理理念、管控方式、风控模式、党建廉政要求等各个方面，向国有企业经营管理各项要求和规范“靠齐”、“对标”，真正实现从“民企”到“国企”的重大转变。
            </p>
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <p><img width="100%" :src="img[4]" alt=""></p>
          </el-col>
        </el-row>
        <img width="100%" :src="img[5]" alt="">
        <p>
          有害生物防制作为物业管理行业的一项新兴产业，随着居民生活水平提高、环境卫生意识增强、国家对有害生物防控监管趋严等因素影响，有害生物防制行业逐步得到市场的接受与认可，特别是新冠疫情暴发以来，社会对消杀需求显著增加，市场规模增长较为明显。在此背景下，东鸿公司、湾区快线集团与广东东尚公司就东进公司股权转让事宜达成共识，并在今天正式签订协议。
        </p>
        <img width="100%" :src="img[6]" alt="">
        <p>下来，东鸿公司、湾区快线集团、广东东尚公司三方将本着“资源共享、优势互补、协同创新、合作共赢”的原则，精诚合作、携手共进，力
          争将东进公司打造成为东莞有害生物防制行业的新标杆、国企民企合作的新典范，为东莞城市建设作出积极贡献。</p>
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News4'})">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;有害生物防制服务能力A级资质评审会顺利召开...</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({name: 'News2'})">广东东进在行动&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News2'})">下一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;广东东进在行动</span>
        </el-col>
      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/news2.png'), require('@/assets/news2-1.png'), require('@/assets/news2-2.png'), require('@/assets/news2-3.png'), require('@/assets/news2-4.png'), require('@/assets/news2-5.png'), require('@/assets/news2-6.png')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    h3 {
      font-size: 16px;
    }

    p {
      padding-left: 25px;
      text-indent: 2.05em;
      font-size: 16px;
      margin: 30px 0;
      text-align: justify;
      color: #666;
      line-height: 24px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
        font-size: 18px;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }

      h3 {
        font-size: 16px;
      }
    }
  }
</style>